<template>
  <div :id="mapId" class="MapBox"></div>
</template>

<script>
import { mapGetters } from "vuex";
import { MARKER_TYPES } from "@/utils/mapUtil/constants";
import {
  initMap,
  clearMarkers,
  fitView,
  loadMarkersBatch,
  findMarkerById,
  zoomPopupMarker,
} from "@/utils/mapUtil/funcs.js";
import {layerServiceURL} from "@/utils/mapUtil/layerServiceURL";
import {handleZoomForBoundary} from "@/utils/mapUtil/leafletFun";

export default {
  data() {
    return {
      mapId: "agricultural-map",
      map: null,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: window.global.view.zoom,
    };
  },
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname"]),
  },
  //监听地区的变化设为中心点
  watch: {
    async topSelectAreaname() {
      await clearMarkers(this.map.tempLayer);
      await this.loadAllMarkers();
      await fitView(this.map);
    },
  },

  mounted() {
    this.init();
    // 监听地图缩放事件, 触发加载对应层级的行政区划边界
    this.map.on('zoomend', this.handleZoomEnd);
  },

  methods: {
    /**
     * 初始化
     */
    async init() {
      this.map = initMap(this.mapId, {
        center: [this.lat, this.lon],
        zoom: this.zoom,
      });
      await this.loadAllMarkers();
      await fitView(this.map);
    },

    /**
     * 添加所有markers
     */
    async loadAllMarkers() {
      try {
        await loadMarkersBatch(
          MARKER_TYPES.agricultural,
          { areaCode: this.topSelectAreacode }, //不加current和size，默认1 和 500
          this.map
        );
      } catch (error) {
        console.error(`添加marker失败, ${type}:`, error);
      }
    },

    /**
     * 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
     */
    handleZoomEnd() {
      const zoomRanges = [
        { layerType: 'service', range: [5, 7], ...layerServiceURL['china_province'] },
        { layerType: 'service', range: [7, 9], ...layerServiceURL['china_city'] },
        { layerType: 'service', range: [9, 12], ...layerServiceURL['china_county'] },
        { layerType: 'service', range: [12, 20], ...layerServiceURL['china_township'] },
      ];
      handleZoomForBoundary(this.map, this, zoomRanges)
    },
  },
};
</script>

<style lang="less" scoped>
.MapBox {
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
